import { requester } from "App";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function ExhibitionList() {
    const [exhibitions, setExhibitions] = useState([]);
    const navigate = useNavigate();
    const textRef = useRef();

    useEffect(() => {
        requester.findAllExhibition((result) => {
            setExhibitions(result.data);
        })
    }, [])

    const handleEdit = (exhibition) => {
        navigate(`/admin/exhibition/list/${exhibition.id}`, { state: { data: exhibition } })
        // 여기에 수정 로직을 추가하세요.
    };

    const headers = ['exhibitionName', 'exhibitionDescription', 'exhibitionImg','type','etc'];

    const styles = {
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        },
        th: {
            backgroundColor: '#f0f0f0',
            color: '#333',
            fontWeight: 'bold',
            padding: '10px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        td: {
            padding: '8px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        button: {
            padding: '5px 10px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer',
        }
    };

    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            if (result && key in result) {
                result = result[key];
            } else {
                return undefined; // 경로에 해당하는 값이 없는 경우
            }
        }
        return result;
    }
    const onSearchClick = () => {
        // let data = {
        //     keyword: textRef.current.getValue()
        // }
        // requester.searchBrand(data, (result) => {
        //     setBrands(result.data);
        // })

        return 
    }
    const onRefreshClick = () => {
        requester.findAllExhibition((result) => {

            setExhibitions(result.data);
        })
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} font={"gmarketSansBold"}>기획전 리스트</P>
                        </Center>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={10}>
                            {/* <FlexChild width={"10%"}>
                                <P weight={700} size={24}>검색 :</P>
                            </FlexChild> */}
                            {/* <FlexChild>
                                <InputText ref={textRef} onEnterPress={onSearchClick} />
                            </FlexChild> */}
                            {/* <FlexChild>
                                <CustomButton text={"검색"} onClick={onSearchClick} />
                            </FlexChild> */}
                            {/* <FlexChild justifyContent={"flex-end"}>
                                <CustomButton text={"검색 초기화"} onClick={onRefreshClick} />
                            </FlexChild> */}
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        {headers.map((header) => (
                                            <th style={styles.th} key={header}>{header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {exhibitions && exhibitions.map((item, index) => (
                                        <tr key={index}>
                                            {headers.slice(0, -1).map((header) => (
                                                <td style={styles.td} key={`${index}-${header}`}>
                                                    {header.endsWith('Img') && getNestedValue(item, header) ? (
                                                        <img src={getNestedValue(item, header)} alt="Product" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                                    ) : (
                                                        getNestedValue(item, header)
                                                    )}
                                                </td>
                                            ))}
                                            <td style={styles.td}>
                                                <button style={styles.button} onClick={() => handleEdit(item)}>Edit</button>
                                            </td>
                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default ExhibitionList;